// api calls for growth chart percentile
export const GROWTH_CHART_PERCENTILE = {
  bmi_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/bmi_for_age_boys.csv",
  bmi_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/bmi_for_age_girls.csv",
  hc_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/hc_for_age_boys.csv",
  hc_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/hc_for_age_girls.csv",
  length_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/length_for_age_boys.csv",
  length_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/length_for_age_girls.csv",
  weight_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/weight_for_age_boys.csv",
  weight_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/weight_for_age_girls.csv",
  weight_for_length_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/weight_for_length_boys.csv",
  weight_for_length_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/weight_for_length_girls.csv",
};

// api calls for growth chart zscore
export const GROWTH_CHART_ZSCORE = {
  bmi_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_bmi_for_age_boys.csv",
  bmi_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_bmi_for_age_girls.csv",
  hc_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_hc_for_age_boys.csv",
  hc_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_hc_for_age_girls.csv",
  length_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_length_for_age_boys.csv",
  length_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_length_for_age_girls.csv",
  weight_for_age_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_weight_for_age_boys.csv",
  weight_for_age_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_weight_for_age_girls.csv",
  weight_for_length_boys:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_weight_for_length_boys.csv",
  weight_for_length_girls:
    "https://asset.connect2clinic.com/erx_graph_csv/z_score_weight_for_length_girls.csv",
};
